export default ({ app }) => {
  const hostname = window.location.hostname || ''
  const search = window.location.search || ''

  const isYandexCache =
    hostname.includes('yandexwebcache') ||
    hostname.includes('webcache.yandex') ||
    (search.includes('fmode=') && search.includes('tm=') && search.includes('sign='))

  if (!isYandexCache) {
    return
  }

  const router = app.router
  if (!router) {
    return
  }

  router.beforeEach((to, from, next) => {
    next(false)
  })

  router.push = () => Promise.resolve()
  router.replace = () => Promise.resolve()
}
